export const BUSINESS = {
  name: "Upscale Concrete Services",
  tagline: "Quality work at an honest price.",
  phone: "0469 305 944",
  phoneIntl: "+61469305944",
  email: "upscaleconcrete1315@gmail.com",
  area: "Ropes Crossing · Sydney, NSW 2760",
  owner: "George",
};

export const SERVICES = [
  {
    id: "driveways",
    no: "01",
    title: "Driveways",
    desc: "Durable, dead-level driveways in plain, coloured or stencilled finishes that lift the whole street front.",
    img: "/media/driveway-townhouse.webp",
  },
  {
    id: "decorative",
    no: "02",
    title: "Decorative Concrete",
    desc: "Exposed aggregate, stencil and coloured concrete — texture and finish tailored to your home.",
    img: "/media/texture-swirl.jpg",
  },
  {
    id: "cove",
    no: "03",
    title: "Cove Finish",
    desc: "Smooth, rolled cove edging around pools and paths for a clean, seamless architectural line.",
    img: "/media/pool-charcoal.jpg",
  },
  {
    id: "slabs",
    no: "04",
    title: "House & Granny Flat Slabs",
    desc: "Engineered slabs poured to spec — the solid, square foundation your build depends on.",
    img: "/media/slab-pour.webp",
  },
  {
    id: "pools",
    no: "05",
    title: "Pool Surrounds",
    desc: "Non-slip, hard-wearing pool surrounds that make the backyard the best room in the house.",
    img: "/media/pool-wide.jpg",
  },
  {
    id: "fencing",
    no: "06",
    title: "Fencing",
    desc: "Retaining and boundary fencing built straight, strong and to last through Sydney seasons.",
    img: "/media/driveway-plain.webp",
  },
];

export const PORTFOLIO = [
  { src: "/media/pool-charcoal.jpg", label: "Charcoal pool surround", span: "lg:col-span-7 lg:row-span-2" },
  { src: "/media/worker-driveway.webp", label: "Broom-finish driveway pour", span: "lg:col-span-5" },
  { src: "/media/driveway-stencil.webp", label: "Stencilled driveway", span: "lg:col-span-5" },
  { src: "/media/pool-wide.jpg", label: "Full pool deck", span: "lg:col-span-6" },
  { src: "/media/driveway-plain.webp", label: "Plain concrete driveway", span: "lg:col-span-6" },
  { src: "/media/pool-1.webp", label: "Cove-edged pool", span: "lg:col-span-4" },
  { src: "/media/pool-2.webp", label: "Textured pool decking", span: "lg:col-span-4" },
];

export const PROCESS = [
  { no: "01", title: "Talk it through", desc: "Call George or send an enquiry. We listen to what you need and book a time to see the site." },
  { no: "02", title: "Honest quote", desc: "A clear, fair quote with no surprises. Quality work at an honest price — always." },
  { no: "03", title: "Prep & pour", desc: "Site prep, formwork and a clean, level pour by a crew that takes pride in every job." },
  { no: "04", title: "Finish & walk-through", desc: "The finish you chose, tidied up and handed over. Concrete built to last for years." },
];
